var React = require('react');

function Equal (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"equal"),React.createElement("path",{"d":"M0 133.388h511.904v73.136h-511.904v-73.136z","key":1}),React.createElement("path",{"d":"M0 305.476h511.904v73.136h-511.904v-73.136z","key":2})]);
}

Equal.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Equal;

Equal.default = Equal;
